__turbopack_context__.v({
  "dialogContent": "DialogContent-module__gS6oHq__dialogContent",
  "dialogContentNoPadding": "DialogContent-module__gS6oHq__dialogContentNoPadding",
  "dialogContentOverflowing": "DialogContent-module__gS6oHq__dialogContentOverflowing",
});
